import { render } from "./Theheader.vue?vue&type=template&id=59c8667b"
import script from "./Theheader.vue?vue&type=script&lang=js"
export * from "./Theheader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__